import { render, staticRenderFns } from "./AlertRentalComponent.vue?vue&type=template&id=8d15f992&"
import script from "./AlertRentalComponent.vue?vue&type=script&lang=js&"
export * from "./AlertRentalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports